import MenuAppBar from "../../components/AppBar/AppBar";
import styled from "styled-components";
import BasicCard from "../../components/Card/Card";
import { useState } from "react";
import { Box } from "@mui/system";
import MiniDrawer from "../../components/Menu/Drawer";
import PureComponent from "../../components/Pie/Pie";
import Bar from "../../components/Pie/Bar";
import Card from "@mui/material/Card";

function Dashboard() {
  return (
    <MiniDrawer>
      {() => (
        <>
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            {/* <Card sx={{ width: "250px", padding: "10px", margin: "1rem" }}>
              <PureComponent />
            </Card> */}
            <Card
              m={2}
              sx={{
                width: "810px",
                minHeight: "250px",
                padding: "10px",
                margin: "1rem",
              }}
            >
              <Bar />
            </Card>
            {/* <Box m={2}>
              <BasicCard minWidth="530px" />
            </Box>
            <Box m={2}>
              <BasicCard minWidth="250px" />
            </Box>
            <Box m={2}>
              <BasicCard minWidth="250px" />
            </Box>
            <Box m={2}>
              <BasicCard minWidth="250px" />
            </Box>
            <Box m={2}>
              <BasicCard minWidth="250px" />
            </Box>
            <Box m={2}>
              <BasicCard minWidth="250px" />
            </Box>
            <Box m={2}>
              <BasicCard minWidth="250px" />
            </Box> */}
          </Box>{" "}
        </>
      )}
    </MiniDrawer>
  );
}

export default Dashboard;
